import React from 'react'

import { Form, Col, AsyncSelect } from '_zari/core'

import { ClearInputGroup } from 'sharedComponents/utils'

import * as ProductosService from 'services/producto.service'

const ProductoOrigenFormGroup = ({ fIsSubmitting, iError, values, setValues }) => {
  const onChange = pickedProducto => {
    values._idProductoOrigen = pickedProducto._idProducto
    values._idProductoPresentacionOrigen = pickedProducto.value
    values.nombreProductoOrigen = pickedProducto.label
    values.unidadMedidaOrigen = pickedProducto.unidadMedida

    setValues(values)
  }

  const clickClear = () => {
    values._idProductoOrigen = ''
    values._idProductoPresentacionOrigen = ''
    values.nombreProductoOrigen = ''
    values.unidadMedidaOrigen = ''
    values._idProductoPromocion = ''
    values._idProductoPresentacionPromocion = ''
    values.nombreProductoPromocion = ''
    values.unidadMedidaPromocion = ''
    values.flagPaso2 = false
    values.factorOrigen = 1
    values.fechaFin = ''
    values.fechaInicio = ''
    values.porcentajeDescuentoPromocion = ''

    setValues(values)
  }

  const loadOptions = (inputValue, resolve) => {
    ProductosService.obtenerAsPromocionesSelect2({
      busqueda: inputValue
    }).then(({ data }) => resolve(data))
  }

  return (
    <Form.Group>
      <Form.Label text='PROD ORIGEN' htmlFor='input-productoOrigen' md={4} alignRightAt='md' />
      <Col md={8}>
        {values._idProductoPresentacionOrigen ? (
          <ClearInputGroup id='input-productoOrigen' iValue={values.nombreProductoOrigen} clickClear={clickClear} />
        ) : (
          <AsyncSelect
            selectId='select2-productoOrigen'
            disabled={fIsSubmitting}
            loadOptions={loadOptions}
            onChange={onChange}
            defaultMenuIsOpen
            autoFocus
          />
        )}
        {iError && <Form.Feedback type='invalid'>{iError}</Form.Feedback>}
      </Col>
    </Form.Group>
  )
}

export default React.memo(ProductoOrigenFormGroup)
